import { t } from '@/i18n'
import type { Tab } from '@/types'

import { DoubleTitle, EmptySeparator, If, InfoItem, Label } from './components'

function generatePaperTicket(tab: Tab) {
  const kitchenOrderTitle = tab.pickupType ? tab.code : tab.name
  return [
    new Label(tab.source?.toUpperCase() ?? '', {
      align: 'center',
      style: '25px'
    }),
    new If(
      kitchenOrderTitle,
      new DoubleTitle(kitchenOrderTitle!, t('tabs.cancelled').toUpperCase(), {
        firstStyle: 'bold 60px',
        secondStyle: '40px',
        firstLineHeight: 70,
        secondLineHeight: 45
      })
    ),
    new If(!kitchenOrderTitle, new EmptySeparator()),
    new If(
      tab.pickupType,
      new InfoItem(`${t('bill.code')} ${tab.source}`, tab.name, {
        important: true,
        fontSize: 20
      })
    ),
    new Label(tab.deliveryOrder!.cancelTime!, {
      style: '18px',
      lineHeight: 30,
      valueType: 'date'
    })
  ]
}

function generateCancelTab(tab: Tab) {
  return generatePaperTicket(tab)
}

export default generateCancelTab
